/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeQuickViewContainerData } from './moe-quick-view-container.data';
import { IMoeQuickViewContainerProps } from './moe-quick-view-container.props.autogenerated';

export interface IMoeQuickViewContainerViewProps extends IMoeQuickViewContainerProps<IMoeQuickViewContainerData> {}

/**
 *
 * MoeQuickViewContainer component
 * @extends {React.PureComponent<IMoeQuickViewContainerProps<IMoeQuickViewContainerData>>}
 */
class MoeQuickViewContainer extends React.PureComponent<IMoeQuickViewContainerProps<IMoeQuickViewContainerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeQuickViewContainer;
